export const initialPolygonState = {
  features: {
    type: "FeatureCollection",
    features: [],
  },
  selectedFeatureIndexes: [],
};

export const BUTTON_DIMENSION = "70px";

export const nonUpdateEditTypes = ["movePosition"];